import type { IPageLayoutAttachment } from '@gik/ui-legacy/gik/AppLayout/AppLayout';
import { AppLayout } from '@gik/ui-legacy/gik/AppLayout/AppLayout';

export type PageLayoutProps = {
  className?: string;
  key?: string;
  headerClassName?: string;
  footerClassName?: string;
} & IPageLayoutAttachment;

export function PageLayout({
  navBarAttachment,
  footerAttachment,
  children,
  className,
  headerClassName,
  footerClassName,
}: React.PropsWithChildren<PageLayoutProps>): React.ReactElement {
  return (
    <AppLayout
      className={className}
      navBarAttachment={navBarAttachment}
      footerAttachment={footerAttachment}
      headerClassName={headerClassName}
      footerClassName={footerClassName}
    >
      {children}
    </AppLayout>
  );
}
